<template>
  <div
    class="col-lg-12 ctr_trm"
    @copy.prevent
    @cut.prevent
    @selectstart.prevent
  >
    <h2 class="head_txt">Aturan Perdagangan (Trading Rules)</h2>
    <p class="p1 subtitle">PT Digital Kripto Indonesia</p>
    <p class="p1">
      Aturan Perdagangan ini memberitahukan anda mengenai Syarat dan Ketentuan
      Pegasus Exchange mengenai Penggunaan produk, layanan, teknologi, dan/atau
      fitur yang disediakan oleh Pegasus Exchange melalui Platform Pegasus
      Exchange (“Aturan Perdagangan”). Platform Pegasus Exchange (sebagaimana
      didefinisikan di bawah) memberikan anda beberapa layanan, termasuk namun
      tidak terbatas pada perdagangan Aset Keuangan Digital, berdasarkan daftar
      Aset Keuangan Digital yang dapat diperdagangkan serta harganya. Aset
      Keuangan Digital ini dapat diakses oleh Konsumen, melalui Platform Pegasus
      Exchange. Berikut adalah Aturan Perdagangan yang mengatur semua Transaksi
      (sebagaimana didefinisikan di bawah) yang dilakukan oleh Konsumen melalui
      Platform Pegasus Exchange.
    </p>
    <p class="p1">
      Aturan Perdagangan ini merupakan instrumen yang satu dan sama, dan
      merupakan bagian yang tidak terpisah dari, Perjanjian Konsumen Pegasus
      Exchange, Syarat dan Ketentuan Pegasus Exchange serta Kebijakan Pegasus
      Exchange lainnya. Pegasus Exchange memohon anda untuk membaca dengan
      seksama perjanjian dan kebijakan tersebut di atas sebelum menggunakan
      Layanan Pegasus Exchange (sebagaimana didefinisikan di bawah).
    </p>
    <h1 class="text_h">I. Definisi dan Istilah</h1>
    <p class="p1">
      Dalam Aturan Perdagangan ini, kecuali jika konteksnya mensyaratkan
      sebaliknya, kata-kata dan istilah-istilah berikut ini memiliki arti
      sebagai berikut:
    </p>
    <p class="p1">Pegasus Exchange berarti PT Digital Kripto Indonesia.</p>
    <p class="p1">
      Akun Pegasus Exchange berarti akun Konsumen yang dibuat untuk menerima
      Layanan Pegasus Exchange yang disediakan kami.
    </p>
    <p class="p1">
      Platform Pegasus Exchange berarti platform dimana Pegasus Exchange akan
      menyediakan layanannya kepada Konsumen. Platform ini dapat berupa situs
      web Pegasus Exchange dan aplikasinya.
    </p>
    <p class="p1">
      Layanan Pegasus Exchange berarti berbagai layanan yang diberikan kepada
      anda oleh Pegasus Exchange yang didasarkan pada teknologi Internet
      dan/atau teknologi blockchain dan ditawarkan melalui situs web Pegasus
      Exchange, aplikasi seluler, dan bentuk lainnya (termasuk bentuk-bentuk
      baru yang akan dimungkinkan oleh perkembangan teknologi di masa depan).
      Layanan Pegasus Exchange termasuk tetapi tidak terbatas pada Platform
      Perdagangan Aset Keuangan Digital dan layanan baru yang akan disediakan
      oleh Pegasus Exchange.
    </p>
    <p class="p1">
      Layanan OTC (Over-the-Counter) berarti fasilitas layanan perdagangan Aset
      Kripto yang disediakan oleh Pegasus Exchange yang memungkinkan Konsumen
      untuk melakukan transaksi jual atau beli dalam volume besar secara
      langsung (Over-the-Counter) dengan kurs yang disepakati, di mana
      pelaksanaan transaksi tersebut dilakukan di luar mekanisme pasar reguler
      atau buku pesanan (order book) yang tersedia pada Platform Pegasus
      Exchange.
    </p>
    <p class="p1">
      Koin berarti salah satu bentuk Aset Keuangan Digital yang memiliki
      konfigurasi blockchain tersendiri dan memiliki karakteristik seperti yang
      muncul pertama kali yaitu bitcoin.
    </p>
    <p class="p1">
      Aset Keuangan Digital berarti komoditas yang tidak berwujud dalam bentuk
      digital dan menggunakan kriptografi, jaringan teknologi informasi, dan
      buku besar yang terdistribusi, untuk mengatur penciptaan unit baru,
      memverifikasi Transaksi, dan mengamankan Transaksi tanpa campur tangan
      pihak lain.
    </p>
    <p class="p1">
      Perjanjian Konsumen berarti suatu perjanjian antara Konsumen dan PT
      Digital Kripto Indonesia sebelum Penggunaan Layanan Pegasus Exchange.
    </p>
    <p class="p1">
      CDD (Customer Due Diligence) berarti kegiatan yang berupa identifikasi,
      verifikasi dan pemantauan yang dilakukan untuk memastikan bahwa Transaksi
      telah sesuai dengan profil, karakteristik dan/atau pola Transaksi Konsumen
      Pegasus Exchange.
    </p>
    <p class="p1">
      Biaya mengacu pada arti yang diberikan kepadanya dalam Klausul VII di
      bawah ini.
    </p>
    <p class="p1">
      Setoran berarti proses menyetorkan sejumlah dana, baik dalam bentuk mata
      uang fiat (seperti Rupiah) maupun Aset Keuangan Digital (seperti Bitcoin
      atau Ethereum), ke dalam akun di platform atau aplikasi tertentu, seperti
      bursa kripto atau wallet digital.
    </p>
    <p class="p1">
      Penarikan berarti proses penarikan dana, baik dalam bentuk mata uang fiat
      (seperti Rupiah) maupun Aset Keuangan Digital (seperti Bitcoin atau
      Ethereum), dari akun di platform atau aplikasi tertentu, seperti bursa
      kripto atau wallet digital, ke rekening bank atau wallet eksternal
      Konsumen.
    </p>
    <p class="p1">
      KYC berarti proses “Know-Your-Customer” yang telah dilakukan oleh Pegasus
      Exchange sebelum menjalankan hubungan bisnis atau melakukan Transaksi
      dengan Konsumen. Sebagai bagian dari proses ini, Pegasus Exchange dapat
      melakukan apapun yang dianggap perlu untuk mengidentifikasi Konsumen,
      melakukan proses verifikasi atas identitas Konsumen, meneliti dan
      menyelidiki Transaksi Konsumen, untuk mematuhi hukum dan peraturan
      perundang-undangan yang berlaku.
    </p>
    <p class="p1">
      Pesanan (Order) berarti suatu instruksi dari Konsumen untuk Penggunaan
      Layanan Pegasus Exchange terkait dengan Perdagangan Crypto-to-crypto.
    </p>
    <p class="p1">
      Buku Order (Order Book) berarti daftar Pesanan (Order) beli dan jual yang
      saat ini terbuka untuk suatu aset, disusun berdasarkan harga.
    </p>
    <p class="p1">
      Perdagangan Spot berarti fasilitas perdagangan yang disediakan oleh
      Pegasus Exchange untuk melakukan perdagangan dengan Konsumen lain di pasar
      melalui Buku Order (Order Book), pada harga pasar saat ini.
    </p>
    <p class="p1">
      Syarat dan Ketentuan berarti suatu perjanjian antara PT Digital Kripto
      Indonesia dan Konsumennya, yang mengatur Penggunaan Platform dan Layanan
      Pegasus Exchange.
    </p>
    <p class="p1">
      Token berarti salah satu bentuk Aset Keuangan Digital yang dibuat sebagai
      produk turunan dari Koin.
    </p>
    <p class="p1">
      Transaksi berarti proses perdagangan Aset Keuangan Digital oleh Konsumen
      di Platform Pegasus Exchange.
    </p>
    <p class="p1">
      Konsumen atau Pengguna berarti semua individu yang mengakses, mengunduh,
      atau menggunakan Layanan Pegasus Exchange dan yang memenuhi kriteria dan
      ketentuan kelayakan yang ditetapkan oleh Pegasus Exchange serta hukum dan
      peraturan perundang-undangan yang berlaku. Untuk menghindari keraguan,
      setiap referensi yang dibuat untuk "Konsumen" dengan ini memiliki arti
      yang sama dengan Konsumen dalam Aturan Perdagangan ini.
    </p>
    <p class="p1">
      Dompet (Wallet) berarti media yang dipergunakan untuk menyimpan Aset
      Keuangan Digital baik berupa Koin atau Token.
    </p>
    <p class="p1">
      OTP (One Time Password) berarti kode sandi unik yang digunakan untuk
      proses autentikasi sekali pakai. OTP biasanya dikirimkan ke perangkat
      Konsumen, seperti ponsel atau email, dan digunakan untuk memverifikasi
      identitas Konsumen dalam transaksi atau akses ke layanan tertentu.
    </p>
    <p class="p1">
      2FA (Two-Factor Authentication) adalah metode keamanan digital yang
      memerlukan dua jenis verifikasi untuk mengonfirmasi identitas Konsumen
      saat mengakses akun atau layanan online. 2FA bertujuan untuk meningkatkan
      keamanan dengan menambahkan lapisan perlindungan ekstra, sehingga lebih
      sulit bagi pihak yang tidak berwenang untuk mendapatkan akses meskipun
      mereka mengetahui kata sandi Konsumen.
    </p>
    <p class="p1">
      Selisih Harga berarti perbedaan antara harga Aset Keuangan Digital yang
      diharapkan oleh Konsumen saat memulai sebuah transaksi dan harga yang
      sebenarnya terealisasi saat transaksi selesai.
    </p>
    <p class="p1">
      Travel Rule berarti peraturan yang diberlakukan oleh Financial Action Task
      Force (FATF) untuk mencegah aktivitas ilegal seperti pencucian uang dan
      pendanaan terorisme dalam transaksi Aset Keuangan Digital.
    </p>
    <h1 class="text_h">II. Proses Pendaftaran Pelanggan/Konsumen</h1>
    <p class="p1">
      1. Semua Transaksi yang dilakukan di Platform Pegasus Exchange adalah
      Transaksi yang telah dilakukan oleh Konsumen Pegasus Exchange yang
      terdaftar.
    </p>
    <h2 class="text_h">
      2. Proses pendaftaran Konsumen akan dilakukan sebagai berikut
    </h2>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Unduh aplikasi Pegasus Exchange dari
        Google Play Store (untuk Android) atau Apple App Store (untuk IOS) untuk
        pengalaman Konsumen yang lebih optimal. Sebagai alternatif, kunjungi
        <a
          href="https://pegasusexchange.id/"
          target="_blank"
          rel="noopener noreferrer"
          >https://pegasusexchange.id/</a
        >
        lalu klik Daftar.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> Isi kolom dengan nama email, kemudian
        kombinasi password minimal 8 karakter (huruf besar/kecil,
        symbol/karakter spesial, dan angka), ID Referensi (Opsional), dan pilih
        dari mana Konsumen mengetahui Pegasus Exchange. Setelah itu klik jika
        Anda sudah membaca dan menyetujui Ketentuan Konsumen. Lalu klik Daftar.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> Silakan konfirmasi email Anda untuk
        mendapatkan kode konfirmasi. Ini untuk memvalidasi email Anda.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">d.</span> Jika sudah berhasil maka akan muncul
        tampilan Info Dasar Rekening Pelanggan.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">e.</span> Jika Anda ingin masuk (login), silakan
        membuka aplikasi Pegasus Exchange, atau sebagai alternatif Anda dapat
        membuka halaman utama kami di
        <a
          href="https://pegasusexchange.id/"
          target="_blank"
          rel="noopener noreferrer"
          >https://pegasusexchange.id/</a
        >, lalu klik Login.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">f.</span> Silakan masukkan alamat email dan
        password yang digunakan di Pegasus Exchange sesuai.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">g.</span> Lalu klik Masuk.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">h.</span> Masukkan Kode OTP jika Konsumen telah
        mengaktifkan keamanan yang digunakan. Pilihan ke Halaman Akun
        2-Factor-Authentication (2FA) selanjutnya, terdiri dari 2 pilihan yaitu
        otentikasi Google (Google Authenticator) dan otentikasi email.
      </li>
      <li class="li-sub">
        <span class="li-label">3.</span> Untuk semua Konsumen, CDD merupakan
        proses yang wajib dijalankan yang mencakup pengumpulan informasi
        identifikasi utama dan dokumen verifikasi. Sebagai bagian dari
        verifikasi, salinan dokumen identifikasi yang dapat diterima atau bukti
        alamat sesuai dengan proses KYC berbasis tier.
      </li>
      <li class="li-sub">
        <span class="li-label">4.</span> Sebagai ilustrasi, dokumen identitas
        yang dapat diterima untuk verifikasi Pelanggan individu termasuk
        identitas nasional yang berlaku, paspor yang valid, Surat Izin Mengemudi
        (“SIM”), atau kartu identitas fotografi lainnya yang dikeluarkan
        pemerintah, seperti yang dinyatakan dalam poin-poin di bawah ini.
      </li>
    </ul>
    <h2 class="text_h">Jenis dokumen identifikasi yang dapat diterima</h2>
    <p class="p1">●Kartu Tanda Penduduk (“KTP”);</p>
    <p class="p1">●Paspor Yang Masih Berlaku;</p>
    <p class="p1">KITAS untuk WNA; atau</p>
    <p class="p1">
      ●Dokumen identitas dengan foto lainnya yang dikeluarkan oleh Pemerintah.
    </p>
    <h2 class="text_h">
      Daftar periksa untuk dokumen identifikasi yang dapat diterima
    </h2>
    <p class="p1">●Nama Lengkap;</p>
    <p class="p1">●Tanggal lahir;</p>
    <p class="p1">●Kebangsaan;</p>
    <p class="p1">●Negara Penerbit;</p>
    <p class="p1">●Tanggal Penerbitan; dan</p>
    <p class="p1">
      ●Tanggal Kedaluwarsa (jika berlaku - tidak boleh merupakan dokumen yang
      sudah kadaluwarsa).
    </p>
    <p class="p1">
      5. Sebagai ilustrasi, dokumen identitas yang dapat diterima untuk
      verifikasi Konsumen Korporasi seperti yang dinyatakan dalam poin-poin di
      bawah ini.
    </p>
    <h2 class="text_h">Jenis dokumen identifikasi yang dapat diterima</h2>
    <p class="p1">● Akta Pendirian &amp; SK Kemenkumham;</p>
    <p class="p1">● Akta Perubahan &amp; SK Kemenhumkan (Jika Ada);</p>
    <p class="p1">● Nomor Induk Berusaha (NIB);</p>
    <p class="p1">
      ● Surat Izin Usaha Perusahaan Sesuai dengan Bidang Usaha Perusahaan;
    </p>
    <p class="p1">● Nomor Pokok Wajib Pajak (NPWP);</p>
    <p class="p1">● Laporan Keuangan Terbaru;</p>
    <p class="p1">● Struktur Manajemen Perusahaan;</p>
    <p class="p1">● Struktur Kepemilikan Perusahaan;</p>
    <p class="p1">
      ● Identitas Direksi dan Dewan Komisaris (Jika Konsumen Asing, melampirkan
      KITAS dan Paspor);
    </p>
    <p class="p1">
      ● Identitas Pihak Berwenang yang Ditunjuk Perusahaan Sebagai Perwakilan
      Perusahaan; dan
    </p>
    <p class="p1">● Identitas Pemilik Manfaat.</p>
    <p class="p1">
      6. Konsumen akan dapat masuk dan melihat harga berbagai pasangan tetapi
      mereka tidak akan dapat menggunakan Layanan dan Transaksi Pegasus Exchange
      lainnya sampai mereka mencapai tingkat akun "Terverifikasi".
    </p>
    <p class="p1">
      7. Pegasus Exchange telah mengadopsi proses KYC berbasis tier untuk
      memastikan keaslian identitas Konsumen dan mencegah pembuatan akun anonim
      atau fiktif. Dengan demikian, semua aset Konsumen tercermin dalam akun
      yang terkait dengan profil mereka, yang secara efektif meningkatkan
      transparansi ekosistem dan meningkatkan kesulitan pencucian uang/pendanaan
      terorisme/pembiayaan proliferasi dan korupsi.
    </p>
    <h2 class="text_h">
      8. Proses verifikasi KYC Konsumen akan dilakukan sebagai berikut
    </h2>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Login ke Akun Pegasus Exchange Anda
        melalui Aplikasi Seluler.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> Klik logo akun Anda di pojok kanan
        atas.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> Pilih identifikasi otentikasi dan pilih
        Verifikasi identifikasi dasar.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">d.</span> Klik tombol verifikasi KYC.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">e.</span> Akan muncul halaman dimana Anda memilih
        kewarganegaraan, jika Indonesia menyiapkan data diri berupa KTP dan jika
        warga negara asing menyiapkan data diri berupa paspor dan KITAS.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">f.</span> Foto KTP secara langsung pastikan KTP
        terlihat jelas (tidak buram dan semua informasi data dapat terbaca
        dengan baik).
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">g.</span> Isikan data diri sesuai KTP pada
        halaman pengisian data.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">h.</span> Setelah itu, Anda akan diarahkan ke
        halaman Liveness untuk melakukan verifikasi wajah, pastikan ruangan Anda
        memiliki cahaya yang cukup dan wajah terlihat jelas di kamera.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">i.</span> Sistem akan merekam wajah Anda untuk
        verifikasi data biometrik dengan menganalisis dan membandingkan
        referensi data. Saat melakukan proses verifikasi wajah ini, jangan
        menggunakan aksesoris apapun pada wajah Anda (misalnya: kacamata,
        masker, dll).
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">j.</span> Klik tombol rekam dan ikuti instruksi
        yang diberikan, pastikan mata Anda sejajar dengan kamera Anda.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">k.</span> Klik submit setelah verifikasi wajah
        berhasil dan selesai.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">l.</span> Proses verifikasi KYC akan disetujui
        dalam waktu kurang dari 1x24 jam oleh sistem jika data verifikasi Anda
        sesuai dengan ketentuan yang diberikan.
      </li>
    </ul>
    <h1 class="text_h">III. Pernyataan dan Jaminan</h1>
    <p class="p1">
      1. Pegasus Exchange tidak akan memberikan jaminan apapun bahwa Platform
      Pegasus Exchange akan selalu dapat diakses setiap saat, karena mungkin ada
      kendala seperti gangguan atau pemeliharaan sistem dan jaringan secara
      berkala.
    </p>
    <p class="p1">
      2. Pegasus Exchange telah memberikan informasi dan penjelasan yang cukup
      mengenai Layanan Pegasus Exchange yang akan diakses oleh Konsumennya yang
      terdaftar dan terverifikasi. Sesuai dengan ketentuan Perjanjian Konsumen
      Pegasus Exchange, Syarat dan Ketentuan, dan Pemberitahuan Risiko, Konsumen
      telah membaca, memahami, menangkap, memperhatikan, menyetujui ketentuan
      yang tercantum di dalamnya, dan bersedia menanggung segala akibat yang
      mungkin timbul sehubungan dengan ketentuan Layanan Pegasus Exchange
      termasuk manfaat, risiko, dan Biaya yang melekat pada layanan tersebut.
    </p>
    <p class="p1">
      3. Sejauh diizinkan oleh hukum dan peraturan perundang-undangan yang
      berlaku, dalam keadaan apa pun tidak boleh ada Pegasus Exchange, pemegang
      saham Pegasus Exchange, pihak usaha patungan, afiliasi dan perusahaan
      serta entitas terkait, dan pejabat, direktur, karyawan, perwakilan, agen,
      pemasok, dan penyedia layanan dari semua orang dan entitas yang dijelaskan
      dalam klausul ini akan bertanggung jawab atau berkewajiban untuk setiap
      kerugian langsung atau tidak langsung (termasuk kehilangan keuntungan,
      bisnis atau peluang), kerusakan atau biaya yang diderita oleh setiap
      Konsumen atau orang atau entitas lain, yang timbul dari atau sehubungan
      dengan tindakan, kelalaian, pelanggaran atau wanprestasi yang dilakukan
      oleh atau disebabkan oleh Konsumen mana pun, termasuk namun tidak terbatas
      pada setiap kegagalan Konsumen dalam menyelesaikan Pesanan (Order)
      dan/atau Transaksi mereka, baik kegagalan ini disebabkan oleh Pegasus
      Exchange atau sebaliknya.
    </p>
    <p class="p1">
      4. Konsumen dengan ini menyatakan dan menjamin bahwa semua data, informasi
      dan dokumen yang diberikan Konsumen kepada Pegasus Exchange adalah benar,
      sah, jujur, transparan, lengkap dan merupakan data, informasi dan dokumen
      yang akurat. Konsumen menyatakan bersedia dilaporkan secara pidana atau
      digugat secara perdata apabila Pegasus Exchange mengetahui atau memperoleh
      informasi dari pihak manapun bahwa data, informasi dan dokumen yang
      diberikan Konsumen tidak benar/tidak sepenuhnya benar/palsu. Konsumen
      bersedia memperbaharui data/informasi jika sewaktu-waktu diminta oleh
      Pegasus Exchange dan semua dokumen yang telah disediakan menjadi milik
      Pegasus Exchange sepenuhnya.
    </p>
    <p class="p1">
      5. Konsumen dengan ini setuju dan memberikan wewenang kepada Pegasus
      Exchange untuk menggunakan seluruh data, informasi dan informasi yang
      diperoleh Pegasus Exchange mengenai Konsumen, termasuk namun tidak
      terbatas pada sarana komunikasi pribadi Konsumen untuk segala keperluan
      lainnya sepanjang memungkinkan dan diizinkan oleh hukum dan peraturan
      perundang-undangan yang berlaku, termasuk untuk tujuan pemasaran Layanan
      Pegasus Exchange, atau lainnya untuk pihak yang bekerja sama dengan
      Pegasus Exchange. Untuk Penggunaan data yang memerlukan persetujuan pihak
      lain, Konsumen dengan ini menyatakan telah memperoleh persetujuan tertulis
      dari pihak ketiga mana pun atas Penggunaan data dan informasi tersebut.
    </p>
    <p class="p1">
      6. Konsumen dengan ini menyatakan dan menjamin untuk tidak menggunakan
      Layanan Pegasus Exchange untuk perdagangan Aset Keuangan Digital yang
      terkait dengan: (i) narkotika, bahan dan/atau zat kimia untuk penelitian;
      (ii) uang dan segala sesuatu yang serupa dengan uang, termasuk derivative;
      (iii) barang dan/atau jasa yang melanggar Hak Kekayaan Intelektual; (iv)
      amunisi, senjata api, bahan peledak, senjata tajam sesuai dengan ketentuan
      hukum yang berlaku; (v) barang dan/atau jasa yang mengungkapkan informasi
      pribadi dari pihak ketiga yang melanggar hukum; (vi) barang dan/atau jasa
      yang terkait dengan pembelian undian, lay-aways; (vii) layanan yang
      terkait dengan perbankan di luar wilayah negara Republik Indonesia; (viii)
      pembayaran dengan kartu; (ix) penyelesaian kredit (credit settlement);
      dan/atau (x) dukungan terhadap organisasi terlarang atau organisasi yang
      dilarang oleh pemerintah.
    </p>
    <p class="p1">
      7. Konsumen dengan ini menyatakan dan menjamin bahwa Transaksi yang
      dilakukan dengan menggunakan Layanan Pegasus Exchange adalah Transaksi
      yang tidak melanggar ketentuan hukum dan peraturan perundang-undangan yang
      berlaku dan ketentuan mengenai pelaksanaan Transaksi sebagaimana diatur
      dalam Perjanjian Konsumen dan Syarat dan Ketentuan. Dalam hal Pegasus
      Exchange menemukan indikasi pelaksanaan Transaksi yang tidak sesuai dengan
      ketentuan peraturan perundang-undangan yang berlaku dan/atau ketentuan
      mengenai penerimaan pelaksanaan Transaksi sebagaimana diatur di dalamnya,
      Pegasus Exchange berhak sepenuhnya untuk mengakhiri atau menangguhkan Akun
      Pegasus Exchange Konsumen dengan menonaktifkan akses Konsumen ke Layanan
      Pegasus Exchange, dan Konsumen dengan ini setuju bahwa Pegasus Exchange
      dengan ini tidak akan memberikan ganti rugi dan/atau menanggung kewajiban
      kepada Konsumen, sepanjang kerugian tersebut bukan disebabkan oleh
      kesalahan, kelalaian, atau kegagalan sistem Pegasus Exchange.
    </p>
    <p class="p1">
      8. Konsumen menyatakan dan menjamin untuk tidak menggunakan Layanan
      Pegasus Exchange untuk tindakan yang terlibat dalam praktik perjudian
      dan/atau aktivitas lain yang mengenakan biaya masuk dan menjanjikan
      hadiah, termasuk namun tidak terbatas pada permainan kasino, perjudian
      dalam olahraga, bisnis yang memfasilitasi perjudian dan metode undian.
    </p>
    <p class="p1">
      9. Konsumen dengan ini menyatakan dan menjamin bahwa risiko Penggunaan
      layanan, produk, dan promosi pihak ketiga dengan Konsumen (jika ada),
      ditanggung oleh Konsumen, dan Konsumen mengakui bahwa Pegasus Exchange
      tidak bertanggung jawab atas layanan dan kinerja pihak ketiga.
    </p>
    <p class="p1">
      10. Konsumen dengan ini menyatakan dan menjamin kepada Pegasus Exchange
      bahwa Konsumen tidak akan memperbanyak dan atau membuat, memberikan,
      menyewakan, menjual, memindahkan, mengalihkan, dan atau mengalih-fungsikan
      Layanan baik sebagian atau seluruhnya kepada pihak lain dengan alasan
      apapun, termasuk namun tidak terbatas pada penyalahgunaan Platform Pegasus
      Exchange untuk melakukan Transaksi selain dari yang telah ditentukan dalam
      Syarat dan Ketentuan dengan maksud apapun, termasuk namun tidak terbatas
      untuk kejahatan/penipuan/kecurangan. Apabila Konsumen melanggar ketentuan
      tersebut, maka Konsumen wajib bertanggung jawab atas segala kerugian,
      tuntutan dan/atau gugatan yang timbul akibat dari pelanggaran tersebut dan
      dengan ini setuju bahwa Pegasus Exchange tidak akan memberikan ganti rugi
      dan atau pertanggungjawaban dalam bentuk apapun kepada Konsumen atau pihak
      manapun atas segala klaim dan/atau tuntutan dan/atau gugatan yang timbul
      akibat pelanggaran tersebut.
    </p>
    <p class="p1">
      11. Konsumen telah mempertimbangkan dan akan mematuhi setiap dan semua
      aspek skema perpajakan yang berlaku untuk anda dan Penggunaan Layanan
      Pegasus Exchange oleh anda, termasuk kewajiban apa pun sehubungan dengan
      pemotongan, pengumpulan, pelaporan, dan pengiriman uang kepada otoritas
      pajak yang sesuai (jika berlaku).
    </p>
    <p class="p1">
      12. Konsumen mengakui bahwa perlakuan hukum dan peraturan atas produk yang
      umumnya dikenal sebagai Token kriptografi, Token digital, atau mata uang
      kriptografi tidak diselesaikan, dapat berbeda antar yurisdiksi, dan dapat
      sering berubah, dan anda bertanggung jawab untuk terus meninjau
      diizinkannya urusan dengan atau dengan produk tersebut di bawah kerangka
      hukum dan peraturan yang berlaku untuk anda dan Penggunaan anda atas
      Layanan Pegasus Exchange di Republik Indonesia.
    </p>
    <p class="p1">
      13. Konsumen menyatakan dan menjamin akan menggunakan Layanan dengan baik
      dan bertanggung jawab serta tidak melakukan tindakan yang bertentangan
      dengan hukum dan peraturan perundang-undangan Republik Indonesia.
    </p>
    <p class="p1">
      14. Konsumen menyatakan dan menjamin bahwa mereka telah membaca dan
      memahami dengan seksama Aturan Perdagangan ini, serta setiap perjanjian
      lain yang disediakan oleh Pegasus Exchange, termasuk namun tidak terbatas
      pada Perjanjian Konsumen, Syarat dan Ketentuan, Kebijakan Privasi atau
      informasi lain yang disediakan oleh Pegasus Exchange sebelum untuk
      melakukan Transaksi Aset Keuangan Digital
    </p>
    <h1 class="text_h">IV. Kewajiban dan Tanggung Jawab</h1>
    <p class="p1">
      1. Konsumen setuju untuk menanggung setiap risiko, kerugian atau akibat
      yang diderita Konsumen yang disebabkan oleh kerusakan, keterlambatan,
      kehilangan atau kesalahan pengiriman Pesanan (Order) dan komunikasi,
      secara elektronik yang disebabkan oleh Konsumen.
    </p>
    <p class="p1">
      2. Konsumen setuju untuk menanggung segala risiko yang terkait dengan Akun
      Pegasus Exchange laporan atau pemberitahuan Penggunaan layanan Pegasus
      Exchange yang dikirimkan kepada Konsumen diterima atau dibaca atau
      disalahgunakan oleh pihak yang tidak berwenang terhadap Akun Pegasus
      Exchange, dan Password Akun Pegasus Exchange diketahui oleh orang/pihak
      lain karena kesalahan Konsumen.
    </p>
    <p class="p1">
      3. Konsumen dengan ini bertanggung jawab sepenuhnya dan setuju bahwa
      Pegasus Exchange tidak akan memberikan ganti rugi dan atau
      pertanggungjawaban dalam bentuk apapun kepada Konsumen atau pihak manapun
      atas segala kerugian dan atau klaim dan atau tuntutan yang timbul atau
      mungkin dialami oleh Pegasus Exchange sebagai akibat dari kelalaian atau
      kegagalan Konsumen dalam menjalankan Transaksi dan sepanjang kerugian
      tersebut bukan disebabkan oleh kesalahan, kelalaian, atau kegagalan sistem
      Pegasus Exchange.
    </p>
    <p class="p1">
      4. Konsumen dengan ini bertanggung jawab sepenuhnya dan setuju bahwa
      Pegasus Exchange tidak akan memberikan ganti rugi dan/atau
      pertanggungjawaban dalam bentuk apapun kepada Konsumen atau pihak manapun
      atas segala kerugian dan atau klaim dan/atau tuntutan yang timbul atau
      mungkin dialami oleh Pegasus Exchange sebagai akibat dari kelalaian atau
      kegagalan Konsumen dalam hal keamanan password atau kredensial dari Akun
      Pegasus Exchange Konsumen.
    </p>
    <p class="p1">
      5. Konsumen memahami dan menyetujui bahwa Konsumen akan menggunakan Akun
      dan Layanan Pegasus Exchange untuk Transaksi yang tidak bertentangan
      dengan ketentuan hukum dan peraturan perundang-undangan yang berlaku
      dan/atau kebijakan internal Pegasus Exchange dan/atau peraturan lainnya
      yang berlaku secara nasional dan internasional terkait dengan pelaksanaan
      Transaksi baik secara langsung maupun tidak langsung, dan Pegasus Exchange
      tidak akan memberikan ganti rugi dan/atau pertanggungjawaban dalam bentuk
      apapun kepada Konsumen atau pihak manapun atas segala klaim dan/atau
      tuntutan dan/atau kerugian yang timbul sehubungan dengan Penggunaan
      Layanan oleh Konsumen untuk Transaksi yang termasuk dalam kategori
      Transaksi mencurigakan dan/atau Transaksi yang dilarang oleh ketentuan
      hukum dan peraturan perundang-undangan yang berlaku dan/atau kebijakan
      internal Pegasus Exchange dan/atau peraturan nasional dan internasional
      lainnya yang berlaku terkait dengan aktivitas Transaksi yang dilakukan
      Konsumen baik secara langsung atau tidak langsung.
    </p>
    <p class="p1">
      6. Semua Konsumen Pegasus Exchange dan layanannya memahami dan menyetujui
      bahwa sumber dana mereka adalah kegiatan ekonomi yang sah dan dana mereka
      tidak berasal dari kegiatan ilegal. Pegasus Exchange berhak untuk meminta
      bukti sumber kekayaan atau sumber dana dari Konsumen terdaftar, baik
      pribadi maupun institusi, sesuai dengan ketentuan hukum dan peraturan
      perundang-undangan yang berlaku. Pegasus Exchange mempertahankan sikap
      kerja sama dengan otoritas penegak hukum secara global dan tidak akan ragu
      untuk melakukan tindakan termasuk namun tidak terbatas pada penyitaan,
      pembekuan, pembatasan atau pengakhiran akun dan/atau dana Konsumen yang
      ditandai, diselidiki atau diwajibkan berdasarkan proses hukum yang sah.
    </p>
    <p class="p1">
      7. Dalam melakukan Transaksi menggunakan Platform Pegasus Exchange,
      Konsumen mengerti dan menyetujui bahwa terdapat sanksi-sanksi tertentu
      yang dikenakan oleh pemerintah, termasuk pemerintah negara lain, dan/atau
      instansi berwenang lainnya pada beberapa negara, badan dan perorangan.
      Mengacu pada hal tersebut, Pegasus Exchange berhak untuk tidak
      melaksanakan/memproses Transaksi yang merupakan pelanggaran terhadap
      ketentuan sanksi tersebut, dan instansi berwenang dapat mensyaratkan
      pengungkapan informasi terkait. Pegasus Exchange tidak bertanggung jawab
      apabila Pegasus Exchange atau pihak lain gagal atau menunda pelaksanaan
      Transaksi, atau adanya pengungkapan informasi sebagai akibat pelanggaran
      langsung maupun tidak langsung atas ketentuan sanksi tersebut.
    </p>
    <p class="p1">
      8. Konsumen bertanggung jawab untuk meninjau dan memahami kerangka hukum
      dan peraturan perundang-undangan yang berlaku untuk anda dan Penggunaan
      anda atas Layanan Pegasus Exchange di Republik Indonesia, dan anda sebagai
      Konsumen, menyatakan dan menjamin bahwa Penggunaan Layanan Pegasus
      Exchange oleh anda diperbolehkan di bawah rezim hukum dan peraturan
      tersebut.
    </p>
    <h1 class="text_h">V. Pembaruan Data</h1>
    <p class="p1">
      1. Konsumen Platform Pegasus Exchange setuju untuk memperbarui informasi
      pribadi mereka yang diberikan kepada Pegasus Exchange untuk keperluan
      verifikasi data.
    </p>
    <h2 class="text_h">
      2. Kegiatan pengkinian data Konsumen bermaksud untuk mencapai tujuan
      berikut
    </h2>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Menganalisis dan menentukan risiko
        bahwa aktivitas Konsumen, untuk jangka waktu sejak pemeriksaan terakhir,
        umumnya dianggap sesuai dengan profil Konsumen;
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> Memastikan bahwa penjelasan-penjelasan
        dicari dan/atau informasi lebih lanjut diperoleh apabila muncul suatu
        Transaksi atau aktivitas yang tidak sesuai/tidak wajar; dan
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> Memastikan profil terkini Konsumen.
      </li>
    </ul>
    <h1 class="text_h">VI. Prosedur Transaksi</h1>
    <h2 class="text_h">1. Jual dan Beli Aset Keuangan Digital</h2>
    <p class="p1">●Menjual Aset Keuangan Digital</p>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Masuk ke akun Anda, lalu pilih menu
        Tukar.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> Masukkan jumlah aset Keuangan Digital
        yang ingin Konsumen jual pada opsi Jual.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> Klik tombol merah muda untuk Jual.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">d.</span> Tunggu hingga muncul notifikasi
        “Sukses” dan masuk ke Buku Pesanan.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">e.</span> Kemudian jika penjualan berhasil maka
        akan masuk ke Riwayat Pesanan Konsumen.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">f.</span> Saldo akhir dapat dicek di menu Dompet.
      </li>
    </ul>
    <p class="p1">●Membeli Aset Keuangan Digital</p>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Masuk ke akun Anda, lalu pilih menu
        Tukar.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> Untuk melihat jenis kripto lihat menu
        ini.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> Masukkan jumlah aset Keuangan Digital
        yang ingin dibeli Konsumen pada opsi Beli.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">d.</span> Klik tombol hijau untuk Membeli.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">e.</span> Tunggu hingga muncul notifikasi
        “Sukses” dan masuk ke Buku Pesanan.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">f.</span> Kemudian jika pembelian berhasil maka
        akan masuk ke Riwayat Pesanan Pelanggan
      </li>
    </ul>
    <h2 class="text_h">2. Setoran Fiat</h2>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Proses Setoran Fiat melalui bank di
        Platform Pegasus Exchange, akan dilakukan sebagai berikut:
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">i.</span> Konsumen membuka aplikasi Pegasus
        Exchange atau mengunjungi situs web Pegasus Exchange;
      </li>
      <ul class="ul-sub ul-nested">
        <li class="li-sub">
          Konsumen memilih opsi untuk melakukan deposit melalui saluran
          perbankan (didukung oleh penyedia layanan pembayaran);
        </li>
        <li class="li-sub">
          Konsumen mengaktifkan layanan pembayaran saluran perbankan dan Dompet
          (Wallet) digitalnya yang terhubung ke aplikasi Pegasus Exchange atau
          situs web Pegasus Exchange;
        </li>
        <li class="li-sub">
          Konsumen memasukkan jumlah yang akan disetorkan dan mengonfirmasi
          Transaksi; dan
        </li>
      </ul>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">v.</span> Saldo akan diperbarui di Dompet
        (Wallet) digital Konsumen yang dihosting oleh mitra pembayaran. Konsumen
        dapat memanfaatkan saldo di Dompet (Wallet) digital untuk melakukan
        pembelian Aset Keuangan Digital.
      </li>
      <ul class="ul-sub ul-nested">
        <li class="li-sub">
          Seluruh transaksi wajib dilakukan melalui rekening bank dengan nama
          pemilik yang identik dan selaras dengan nama Konsumen yang terdaftar
          serta terverifikasi pada akun sesuai identitas resmi (KTP/Paspor).
          Penggunaan rekening bank milik pihak ketiga dalam bentuk apa pun tidak
          diperkenankan, dan apabila ditemukan ketidaksesuaian data, Perusahaan
          memiliki wewenang penuh untuk menangguhkan, menolak, atau membatalkan
          transaksi tersebut secara sepihak, di mana segala biaya administrasi
          serta risiko kerugian yang timbul menjadi tanggung jawab sepenuhnya
          dari Konsumen.
        </li>
      </ul>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> Proses Setoran Dompet (Wallet)
        Elektronik di Platform Pegasus Exchange, akan dilakukan sebagai berikut:
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">i.</span> Konsumen mengunjungi situs web Pegasus
        Exchange;
      </li>
      <ul class="ul-sub ul-nested">
        <li class="li-sub">
          Konsumen memilih opsi untuk melakukan deposit melalui Dompet (Wallet)
          elektronik (didukung oleh penyedia layanan pembayaran yang bekerjasama
          dengan Pegasus Exchange);
        </li>
        <li class="li-sub">
          Penyedia layanan pembayaran Pegasus Exchange akan mengkreditkan jumlah
          dari Dompet (Wallet) elektronik ke Dompet (Wallet) digital yang
          diselenggarakan oleh penyedia layanan pembayaran di halaman situs web
          Pegasus Exchange.
        </li>
      </ul>
    </ul>
    <h2 class="text_h">3. Penarikan Fiat dan Aset Keuangan Digital lainnya</h2>
    <p class="p1">
      Berbeda dengan pembelian Aset Keuangan Digital, Konsumen mungkin ingin
      menjual Aset Keuangan Digital mereka langsung kepada Pegasus Exchange .
      Dalam keadaan seperti itu, Pegasus Exchange akan membeli aset-aset ini
      dengan harga yang dapat dieksekusi (yang akan didasarkan pada harga pasar
      spot).
    </p>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Jika Anda sudah berhasil login ke akun
        Anda, silakan pilih dompet Anda.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> Kemudian pilih Penarikan. Pada menu ini
        terdapat dua pilihan untuk melakukan penarikan yaitu IDR dan Crypto.
        Pilih kolom Kripto untuk penarikan Aset Keuangan Digital dan pilih kolom
        IDR untuk penarikan fiat.
      </li>
    </ul>
    <p class="p1">
      Untuk penarikan fiat, pilih tambahkan rekening dan lengkapi data bank yang
      ingin Anda masukkan.
    </p>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> Klik rekening bank yang ingin dipilih
        dan pastikan nama pemilik rekening sesuai dengan nama Konsumen.
        Kemudian, klik "Selanjutnya".
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">d.</span> Masukkan jumlah penarikan minimal Rp
        100.000, lalu klik "Kirim".
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">e.</span> Untuk Penarikan Aset Keuangan Digital,
        klik kolom Kripto lalu pilih jenis Aset Keuangan Digital yang akan
        ditarik.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">f.</span> Klik “Pilih Jaringan” dan perhatikan
        Minimum dan Maksimum Penarikan setiap Aset Keuangan Digital.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">g.</span> Masukkan alamat penerima dan jumlah
        Aset Keuangan Digital yang akan dikirim. Pastikan alamat tujuan sudah
        benar.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">h.</span> Klik “Kirim”. Penarikan akan diproses
        secepat mungkin dalam waktu 1x24 jam.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">i.</span> Semua penarikan akan dicatat dalam
        Riwayat Penarikan fiat atau kripto.
      </li>
    </ul>
    <h2 class="text_h">4. Perdagangan Spot</h2>
    <p class="p1">
      Perdagangan Spot memungkinkan Konsumen untuk melakukan transaksi jual dan
      beli aset kripto dengan Konsumen lain di pasar melalui Buku Order (Order
      Book), yaitu sistem yang menampilkan daftar penawaran jual (ask) dan
      permintaan beli (bid) yang disusun berdasarkan harga dan waktu.
    </p>
    <p class="p1">
      Konsumen dapat memasukkan Pesanan (Order) sesuai dengan jenis order yang
      tersedia. Transaksi akan terjadi ketika Pesanan Konsumen bertemu dan
      dipenuhi oleh Pesanan Konsumen lain yang sesuai di dalam Buku Order, baik
      secara langsung maupun pada harga yang ditentukan oleh Konsumen.
    </p>
    <p class="p1">Jenis Pesanan (Order Type)</p>
    <ul class="ul-letter">
      <li class="li-letter"><span class="li-label">a.</span> Market Order</li>
    </ul>
    <p class="p1">
      Market Order adalah Pesanan yang dieksekusi segera dengan harga terbaik
      yang tersedia di Buku Order pada saat Pesanan dimasukkan. Jenis Pesanan
      ini memprioritaskan kecepatan eksekusi dan dapat menghasilkan harga
      transaksi yang berbeda tergantung pada likuiditas pasar saat itu. Nilai
      transaksi minimum untuk perdagangan Spot di Pegasus Exchange adalah Rp
      2.000 atau ekuivalen.
    </p>
    <ul class="ul-letter">
      <li class="li-letter"><span class="li-label">b.</span> Limit Order</li>
    </ul>
    <p class="p1">
      Limit Order adalah Pesanan yang memungkinkan Konsumen untuk menentukan
      harga beli atau harga jual tertentu. Pesanan hanya akan dieksekusi apabila
      harga pasar mencapai harga yang ditentukan oleh Konsumen. Jika belum
      terpenuhi, Pesanan akan tetap tercatat di Buku Order hingga dieksekusi
      atau dibatalkan oleh Konsumen
    </p>
    <ul class="ul-letter">
      <li class="li-letter"><span class="li-label">c.</span> Flash Trade</li>
    </ul>
    <p class="p1">
      Flash Trade adalah fitur perdagangan yang memungkinkan Konsumen untuk
      melakukan transaksi aset kripto dengan mekanisme kuotasi harga langsung
      (Request for Quote/RFQ), tanpa melalui Buku Order. Dalam Flash Trade,
      Konsumen mengajukan permintaan harga untuk jumlah aset tertentu. Sistem
      akan menampilkan harga kuotasi final yang berlaku dalam jangka waktu
      tertentu. Apabila Konsumen menyetujui harga tersebut dalam periode yang
      ditentukan, transaksi akan dieksekusi secara langsung sesuai dengan harga
      kuotasi yang ditampilkan. Fitur Flash Trade dirancang untuk memberikan
      kepastian harga pada transaksi dengan nominal tertentu, tanpa
      ketergantungan pada antrean Buku Order atau perubahan harga pasar selama
      proses eksekusi.
    </p>
    <h2 class="text_h">
      5. Pengiriman Aset Keuangan Digital ke Dompet (Wallet) Lain
    </h2>
    <p class="p1">
      Konsumen dapat mengirimkan Aset Keuangan Digital melalui Akun miliknya ke
      Wallet milik Konsumen lain pada Platform Pegasus Exchange atau ke Wallet
      di luar Platform Pegasus Exchange. Khusus untuk pengiriman Aset Keuangan
      Digital ke Wallet di luar Platform Pegasus Exchange, Konsumen akan
      dikenakan Biaya Blockchain. Selain mengirim Aset Keuangan Digital,
      Konsumen juga dapat menerima Aset Keuangan Digital yang dikirim oleh
      Konsumen lain.
    </p>
    <p class="p1">
      Konsumen paham dan setuju bahwa ketika Konsumen mengirimkan Aset Keuangan
      Digital dari Wallet internal Pegasus Exchange ke Wallet eksternal Pegasus
      Exchange atau pihak ketiga mengirimkan Aset Keuangan Digital dari Wallet
      luar Pegasus Exchange ke Wallet Pegasus Exchange, pihak yang melakukan
      transaksi bertanggung jawab sepenuhnya untuk melakukan eksekusi transaksi
      secara benar, termasuk untuk memastikan alamat Wallet tujuan sudah tepat.
      Kurangnya blockchain fee dapat menyebabkan transaksi yang dilakukan
      tertunda di luar kendali Pegasus Exchange dan kurang akuratnya alamat
      Wallet tujuan dapat berakibat pada hilangnya Aset Keuangan Digital
      Konsumen. Pegasus Exchange tidak bertanggung jawab atas tertundanya atau
      hilangnya Aset Keuangan Digital Konsumen yang diakibatkan oleh kesalahan
      atau kelalaian yang terjadi.
    </p>
    <h1 class="text_h">VI. Mekanisme Transaksi Layanan OTC</h1>
    <p class="p1">
      1. Konsumen dapat mengakses dan menggunakan Layanan OTC dengan terlebih
      dahulu masuk (login) ke dalam Platform Pegasus Exchange menggunakan
      kredensial Akun Pegasus Exchange Konsumen (email dan kata sandi) yang
      telah terverifikasi saat proses pendaftaran. Konsumen bertanggung jawab
      penuh untuk menjaga kerahasiaan kata sandi, akses Akun Pegasus Exchange,
      PIN/2FA, dan segala jenis aktivitas yang terjadi di dalam Akun Pegasus
      Exchange Konsumen. Konsumen wajib segera menghubungi Pegasus Exchange
      apabila terjadi dugaan Penggunaan Akun Pegasus Exchange tanpa izin.
      Pegasus Exchange tidak bertanggung jawab atas kerugian yang ditimbulkan
      akibat adanya penyalahgunaan Akun Pegasus Exchange dan/atau kata sandi,
      dengan atau tanpa sepengetahuan Konsumen, saat menggunakan Layanan OTC
    </p>
    <p class="p1">
      2. Konsumen dapat memulai permintaan transaksi OTC dengan menghubungi OTC
      Desk Pegasus Exchange secara langsung untuk mengajukan detail transaksi
      yang diinginkan, meliputi jenis Aset Kripto, jumlah, dan arah transaksi
      (on/off ramp), dan sehubungan dengan itu, Konsumen menyatakan kesediaannya
      untuk bergabung dalam Saluran Komunikasi Resmi yang ditetapkan oleh
      Pegasus Exchange dari waktu ke waktu guna keperluan koordinasi Layanan
      OTC.
    </p>
    <p class="p1">
      3. Berdasarkan permintaan transaksi tersebut, Pegasus Exchange akan
      menetapkan Kurs Indikatif. Kurs Indikatif ini akan ditawarkan kepada
      Konsumen dan hanya berlaku mengikat untuk disetujui selama periode 3
      (tiga) menit sejak ditawarkan melalui Saluran Komunikasi Resmi. Apabila
      Konsumen menyetujui kurs dalam batas waktu tersebut, Pegasus Exchange akan
      melakukan penguncian kurs.
    </p>
    <p class="p1">
      4. Konsumen selanjutnya wajib melakukan pengisian Formulir Pemesanan
      selama periode 3 (tiga) menit sejak diberikan Formulir Pemesanan.
      Pengiriman Formulir Pemesanan Konsumen merupakan bukti persetujuan final
      Konsumen atas transaksi Layanan OTC.
    </p>
    <p class="p1">
      5. Media komunikasi yang digunakan untuk koordinasi transaksi Layanan OTC
      antara Konsumen dan Pegasus Exchange adalah melalui Saluran Komunikasi
      Resmi. Pegasus Exchange dapat bekerja sama dengan mitra likuiditas pihak
      ketiga untuk penyediaan kurs dan likuiditas atas setiap transaksi OTC yang
      masuk.
    </p>
    <p class="p1">
      6. Setelah Pegasus Exchange menerima Formulir Pemesanan, Pegasus Exchange
      akan memberikan Konfirmasi Pemesanan melalui Saluran Komunikasi Resmi,
      Konsumen harus melakukan deposit dana (fiat) atau Aset Kripto sesuai
      dengan jumlah dalam Konfirmasi Pemesanan melalui dan/atau ke
      rekening/alamat dompet lembaga kliring penjaminan dan penyelesaian
      perdagangan aset keuangan digital termasuk aset kripto yang bekerja sama
      dengan penyelenggara bursa aset keuangan digital termasuk aset kripto,
      dalam waktu maksimal 15 (lima belas) menit sejak Konfirmasi Pemesanan
      diberikan oleh OTC Desk Pegasus Exchange. Apabila Konsumen tidak melakukan
      deposit dalam jangka waktu tersebut, maka transaksi akan dianggap batal
      secara otomatis dan kurs yang telah dikunci tidak lagi berlaku.
    </p>
    <p class="p1">
      7. Pegasus Exchange akan melaksanakan penyelesaian atas pesanan Konsumen
      setelah lembaga kliring penjaminan dan penyelesaian perdagangan aset
      keuangan digital termasuk aset kripto mengonfirmasi penyelesaian kewajiban
      deposit dana atau Aset Kripto dari Konsumen. Transaksi OTC dianggap
      selesai dan berhasil pada saat Aset Kripto atau dana fiat telah efektif
      masuk ke dalam Akun Pegasus Exchange milik Konsumen, di mana konfirmasi
      keberhasilan tersebut akan disampaikan oleh Pegasus Exchange melalui
      Saluran Komunikasi Resmi.
    </p>
    <p class="p1">
      8. Konsumen setuju untuk tidak menggunakan Layanan OTC untuk melakukan
      tindakan melawan hukum dalam bentuk apapun, termasuk namun tidak terbatas
      pada pencucian uang, pendanaan terorisme, perjudian, pembelian barang
      ilegal, atau kegiatan peretasan (hacking). Pegasus Exchange berhak
      membekukan Akun Pegasus Exchange, dana, dan Aset Kripto di dalamnya serta
      menghentikan akses Layanan OTC apabila menemukan aktivitas yang
      mencurigakan atau indikasi pelanggaran hukum.
    </p>
    <p class="p1">
      9. Pegasus Exchange dapat membebankan biaya layanan untuk memproses
      transaksi OTC atas nama Konsumen. Selain itu, Konsumen memahami bahwa
      transaksi Aset Kripto dapat dikenakan pajak dan biaya lain sesuai
      peraturan perundang-undangan yang berlaku.
    </p>
    <p class="p1">
      10. Pegasus Exchange wajib melakukan pelaporan dan pencatatan atas seluruh
      transaksi Layanan OTC kepada penyelenggara bursa aset kripto serta kepada
      lembaga kliring penjaminan dan penyelesaian, sesuai dengan ketentuan
      peraturan perundang-undangan yang berlaku di bidang perdagangan pasar
      fisik aset kripto.
    </p>
    <h1 class="text_h">VII. Biaya Transaksi dan Batas Penarikan Dana</h1>
    <p class="p1">
      1. Proses penerapan Biaya Transaksi oleh Pegasus Exchange dilakukan sesuai
      dengan ketentuan yang tercantum dalam Jadwal Biaya. Untuk daftar lengkap
      Aset Keuangan Digital yang diperdagangkan beserta jadwal biayanya, silakan
      merujuk ke situs web resmi kami. Mohon diperhatikan bahwa jadwal biaya
      dapat berubah sewaktu-waktu tanpa pemberitahuan terlebih dahulu.
    </p>
    <h2 class="text_h">
      2. Berikut adalah batas penarikan yang diterapkan oleh Pegasus Exchange
    </h2>
    <p class="p1">●Batas Penarikan Fiat</p>
    <p class="p1">Per Transaksi: Min. Rp100.000 — Maks. Rp1 Miliar.</p>
    <p class="p1">Batas Harian: Maks. Rp10 Miliar.</p>
    <p class="p1">
      Catatan: Konsumen dapat melakukan beberapa kali penarikan hingga mencapai
      batas kumulatif harian
    </p>
    <p class="p1">●Batas Penarikan Kripto</p>
    <p class="p1">
      Semua batas penarikan aset kripto dikonversi berdasarkan kurs pasar yang
      berlaku ke USD:
    </p>
    <p class="p1">Per Transaksi: setara Min. $10 — Maks. $50.000.</p>
    <p class="p1">Batas Harian: setara Maks. $100.000.</p>
    <p class="p1">Batas Bulanan: setara Maks. $1.000.000.</p>
    <h1 class="text_h">VIII. Keamanan Transaksi</h1>
    <p class="p1">
      Untuk keamanan dalam bertransaksi, Konsumen dapat menerapkan 2FA (Two
      Factor Authentication). 2FA (Two Factor Authentication) adalah sebuah
      fitur keamanan online, dimana Konsumen akan melakukan verifikasi identitas
      sebanyak 2 (dua) kali. Misalnya, jika Konsumen ingin melakukan log in pada
      akun Pegasus Exchange setelah memasukan password kombinasi, Konsumen akan
      diminta kembali untuk memasukan kode khusus yang dikirim melalui SMS atau
      menggunakan kode Google Authenticator. Konsumen dapat mengaktifkan 2FA SMS
      atau 2FA Google Authenticator di Pegasus Exchange . Kegunaan fitur
      keamanan 2FA ini agar akun, data, aset, serta riwayat transaksi tidak
      diketahui oleh pihak yang tidak bertanggung jawab.
    </p>
    <h2 class="text_h">
      Berikut cara mengaktifkan 2FA Google Authenticator di Pegasus Exchange
    </h2>
    <p class="p1">1.Melakukan Login, dan masuk ke menu Info Dasar.</p>
    <p class="p1">2.Kemudian pilih Keamanan akun.</p>
    <p class="p1">
      3.Jika sudah berhasil masuk ke menu Keamanan akun, silahkan memilih 2FA
      Otentikasi Google dan aktifkan.
    </p>
    <h2 class="text_h">
      4.Kemudian setelah pilih Aktifkan, selesaikan - langkah berikut
    </h2>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Pastikan sudah menginstall Google
        Authenticator pada Handphone yang akan digunakan.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> Pindai kode QR di aplikasi Google
        authenticator.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> Harap simpan kunci ini pada kertas.
        Kunci ini untuk memulihkan Google Authenticator jika terjadi kehilangan
        handphone.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">d.</span> Aktifkan Google Authenticator dengan
        memasukan kode yang dikirim melalui e-mail atau SMS
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">e.</span> 2FA Google Authenticator sudah aktif.
      </li>
    </ul>
    <h1 class="text_h">IX. Layanan Pengaduan dan Penyelesaian Perselisihan</h1>
    <p class="p1">
      1. Jika ada keluhan atau masalah terkait Penggunaan Layanan Pegasus
      Exchange atau Platform Pegasus Exchange, Konsumen akan dirujuk ke Tim
      Layanan Konsumen Pegasus Exchange .
    </p>
    <h2 class="text_h">
      2. Prosedur untuk menyelesaikan keluhan Pegasus Exchange adalah sebagai
      berikut:
    </h2>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">i.</span> Konsumen dapat menyampaikan keluhan apa
        pun kepada Pegasus Exchange melalui Support Center Pegasus Exchange,
        saluran Social Media Pegasus Exchange, dan Community Feedback Pegasus
        Exchange;
      </li>
      <ul class="ul-sub ul-nested">
        <li class="li-sub">
          Setelah menerima keluhan Konsumen, keluhan akan diteruskan ke Tim
          Customer Support;
        </li>
        <li class="li-sub">
          Pegasus Exchange akan memberikan pengakuan tertulis atas pengaduan
          tersebut dalam waktu 5 (lima) hari kerja sejak diterimanya pengaduan;
        </li>
        <li class="li-sub">
          Pengaduan akan diteruskan ke Tim Pengaduan, di mana akan dialokasikan
          nomor pelacakan kasus;
        </li>
      </ul>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">v.</span> Pengaduan tersebut kemudian akan
        diselidiki oleh Tim Pengaduan.
      </li>
      <ul class="ul-sub ul-nested">
        <li class="li-sub">
          Tanggapan akhir akan diberikan oleh Pegasus Exchange kepada Konsumen
          dalam waktu 35 (tiga puluh lima) hari kerja sejak diterimanya
          pengaduan.
        </li>
      </ul>
    </ul>
    <ul class="ul-sub">
      <li class="li-sub">
        <span class="li-label">3.</span> Setiap perselisihan Konsumen atau
        Pelanggan yang timbul dari Penggunaan Layanan Pegasus Exchange akan
        dilakukan melalui prosedur berikut:
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Musyawarah bersama untuk mencapai
        mufakat antara Konsumen dan Pegasus Exchange;
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> Jika Konsumen merasa pengaduannya tidak
        ditangani dengan baik, Konsumen dapat melaporkan permasalahan tersebut
        kepada Otoritas Jasa Keuangan (OJK). OJK memiliki wewenang untuk
        melakukan evaluasi, memberikan rekomendasi, dan mengawasi penyelesaian
        sengketa sesuai dengan peraturan yang berlaku;
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> Dalam hal tidak tercapai mufakat,
        perselisihan dapat diselesaikan melalui Lembaga Alternatif Penyelesaian
        Sengketa Sektor Jasa Keuangan (LAPS SJK), yang berfungsi sebagai
        mekanisme penyelesaian sengketa di luar pengadilan. Penyelesaian melalui
        LAPS bersifat final dan mengikat, kecuali para pihak memilih untuk
        melanjutkan ke proses hukum;
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">d.</span> Dalam hal tidak tercapai mufakat antara
        para pihak, perselisihan tersebut dapat diselesaikan melalui arbitrase
        oleh Badan Arbitrase Nasional Indonesia (BANI), dan tunduk pada
        peraturan BANI yang berlaku pada saat itu (“Peraturan BANI”),
        sebagaimana diatur dalam perjanjian antara Konsumen dan Pegasus
        Exchange; dan
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">e.</span> Pegasus Exchange akan mendokumentasikan
        seluruh proses penyelesaian pengaduan dan memberikan laporan berkala
        kepada OJK. Pegasus Exchange akan memastikan bahwa proses penyelesaian
        sengketa dilakukan secara transparan, adil, dan tidak diskriminatif.
      </li>
    </ul>
    <h1 class="text_h">X. Keadaan Kahar</h1>
    <p class="p1">
      1. Pegasus Exchange tidak akan bertanggung jawab atas keterlambatan atau
      kegagalan untuk pelaksanaan seperti yang dipersyaratkan oleh Aturan
      Perdagangan ini karena sebab atau kondisi apa pun di luar kendali wajar
      Pegasus Exchange.
    </p>
    <p class="p1">
      2. Peristiwa-peristiwa yang dianggap sebagai keadaan kahar adalah keadaan
      apa pun yang tidak berada dalam kendali yang wajar, secara langsung atau
      tidak langsung, termasuk tetapi tidak terbatas pada:
    </p>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> bencana alam, perang, pemberontakan,
        pemogokan, kerusuhan, gempa bumi, badai, banjir atau cuaca buruk,
        ledakan, kebakaran, sambaran kilat, gangguan, blokade, konflik
        bersenjata, atau ancaman serius atas hal-hal tersebut, permusuhan,
        mobilisasi, penahanan, revolusi, keributan, penjarahan, penutupan pabrik
        atau tempat kerja, wabah penyakit, pandemi, epidemi, atau bencana alam
        lainnya dengan ketentuan adanya pernyataan dari pemerintah atau instansi
        yang berwenang yang menyatakan bahwa situasi adalah keadaan darurat;
        atau
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> perubahan undang-undang, peraturan,
        putusan dan/atau kebijakan pemerintah dan/atau tidak dilaksanakannya
        Aturan Perdagangan ini oleh salah satu Pihak yang disebabkan oleh
        pelaksanaan Aturan Perdagangan ini bertentangan dengan setiap hukum dan
        peraturan perundang-undangan yang ada yang mana Pihak tersebut harus
        tunduk memenuhinya.
      </li>
    </ul>
    <h1 class="text_h">
      XI. Penerapan Program Anti Pencucian Uang dan Pencegahan Pendanaan
      Terorisme serta Proliferasi Senjata Pemusnah Massal (“APU-PPT”)
    </h1>
    <p class="p1">
      1. Pegasus Exchange telah merumuskan kebijakan internal terkait Pesanan
      (Order) untuk memastikan kepatuhan terhadap hukum dan peraturan
      perundang-undangan sebagaimana diatur dalam POJK No. 27 Tahun 2024 tentang
      Penyelenggaraan Perdagangan Aset Keuangan Digital termasuk Aset Kripto,
      maupun amandemen dari peraturan tersebut ke depannya.
    </p>
    <p class="p1">
      2. Pegasus Exchange akan memastikan bahwa Platform dan Layanannya tunduk
      pada hukum dan peraturan perundang-undangan negara Republik Indonesia,
      termasuk namun tidak terbatas pada hal-hal berikut:
    </p>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Undang-Undang No. 8 Tahun 2010 tentang
        Pencegahan dan Pemberantasan Tindak Pidana Pencucian Uang;
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> Undang-Undang No. 9 Tahun 2013 tentang
        Pencegahan dan Pemberantasan Tindak Pidana Pendanaan Terorisme;
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> Peraturan Otoritas Jasa Keuangan
        (“POJK”) No. 8 Tahun 2023 tentang Penerapan Program Anti Pencucian Uang,
        Pencegahan Pendanaan Terorisme dan Pencegahan Pendanaan Proliferasi
        Senjata Pemusnah Massal di Sektor Jasa Keuangan;
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">d.</span> Surat Edaran Otoritas Jasa Keuangan
        (“SEOJK”) No. 16 Tahun 2025 tentang Penerapan Program Anti Pencucian
        Uang, Pencegahan Pendanaan Terorisme dan Pencegahan Pendanaan
        Proliferasi Senjata Pemusnah Massal bagi Pedagang Aset Keuangan Digital;
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">e.</span> Peraturan Otoritas Jasa Keuangan
        (“POJK”) No. 23 Tahun 2025 tentang Perubahan atas Peraturan Otoritas
        Jasa Keuangan No. 27 Tahun 2024 tentang Penyelenggaraan Perdagangan Aset
        Keuangan Digital termasuk Aset Kripto;
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">f.</span> POJK No. 27 Tahun 2024 tentang
        Penyelenggaraan Perdagangan Aset Keuangan Digital termasuk Aset Kripto;
        dan
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">g.</span> Peraturan PPATK No. 2 Tahun 2021
        tentang Tata Cara Penyampaian Laporan Transaksi Dan Laporan Transaksi
        Keuangan Mencurigakan Melalui Aplikasi GoAML Bagi Penyedia Barang
        Dan/atau Jasa.
      </li>
    </ul>
    <h2 class="text_h">
      3. Untuk melaksanakan ketentuan tersebut di atas, kebijakan Pegasus
      Exchange minimal meliputi:
    </h2>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Pemisahan Konsumen;
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> CDD dan verifikasi nama Konsumen ritel
        (PEP, daftar sanksi dan media).
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> CDD Berbasis Risiko dan verifikasi
        Konsumen;
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">d.</span> Matriks Risiko Pelanggan di mana
        Konsumen diberi skor sesuai dengan matriks risiko, yang mencakup
        komponen seperti PEP, Usia, Sanksi.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">e.</span> Pegasus Exchange mematuhi Travel Rule,
        yang diwajibkan oleh Financial Action Task Force (FATF). Dalam semua
        transaksi Aset Keuangan Digital, Pegasus Exchange memastikan pengumpulan
        dan transfer informasi pengirim dan penerima yang relevan sesuai dengan
        regulasi yang berlaku.
      </li>
      <li class="li-sub">
        <span class="li-label">4.</span> Pegasus Exchange telah memiliki Divisi
        Hukum dan Kepatuhan (Legal and Compliance) yang ditunjuk untuk berperan
        aktif dalam pelaksanaan pemantauan APU-PPT.
      </li>
    </ul>
    <h1 class="text_h">XII. Penerapan Travel Rule</h1>
    <p class="p1">
      Pegasus Exchange mematuhi Travel Rule, sebagaimana diamanatkan oleh
      Financial Action Task Force (FATF). Dalam menerapkan aturan ini, Pegasus
      Exchange:
    </p>
    <p class="p1">
      1. Mengumpulkan informasi pengirim meliputi nama pengirim, alamat wallet
      pengirim, alamat pengirim, ktp untuk WNI/ paspor dan KITAS untuk WNA dan
      penerima meliputi nama penerima, alamat wallet penerima dan alamat
      penerima untuk transaksi Aset Keuangan Digital yang lebih dari atau sama
      dengan nilai dalam Rupiah setara dengan USD 1.000,00 (seribu dolar
      amerika)
    </p>
    <p class="p1">
      2. Mengumpulkan informasi pengirim meliputi nama pengirim dan alamat
      wallet pengirim dan penerima meliputi nama penerima dan alamat wallet
      penerima untuk transaksi Aset Keuangan Digital yang kurang dari nilai
      dalam Rupiah setara dengan dengan USD 1.000,00 (seribu dolar amerika).
    </p>
    <p class="p1">
      3. Memastikan verifikasi identitas Konsumen melalui proses Know Your
      Customer (KYC) sebelum melakukan transaksi.
    </p>
    <h2 class="text_h">
      4. Menggunakan teknologi untuk berbagi informasi secara aman sesuai dengan
      regulasi yang berlaku.
    </h2>
    <h2 class="text_h">
      5. Memantau semua transaksi untuk mendeteksi aktivitas mencurigakan atau
      ilegal.
    </h2>
    <h1 class="text_h">XIII. Waktu Henti Terjadwal</h1>
    <p class="p1">
      1. Dari waktu ke waktu, Pegasus Exchange dapat menangguhkan perdagangan
      sementara untuk pemeliharaan atau peningkatan. Jika tidak ada keadaan yang
      meringankan, Platform Pegasus Exchange akan menggunakan upaya yang wajar
      untuk proses menutup dan membuka kembali perdagangan.
    </p>
    <p class="p1">
      2. Setiap penghentian sementara perdagangan akan diinformasikan kepada
      Konsumen dan diumumkan di
      <a
        href="https://pegasusexchange.id/"
        target="_blank"
        rel="noopener noreferrer"
        >https://pegasusexchange.id/</a
      >
      dengan prosedur sebagai berikut:
    </p>
    <p class="p1">
      Dari waktu ke waktu, Pegasus Exchange mungkin menghentikan sementara
      perdagangan untuk pemeliharaan atau peningkatan sistem. Jika tidak ada
      ketentuan khusus, Pegasus Exchange akan mengikuti proses ini untuk menutup
      dan membuka kembali perdagangan;
    </p>
    <p class="p1"><strong>Langkah 1: Umumkan Waktu Henti Terjadwal.</strong></p>
    <p class="p1">
      Umumkan waktu henti terjadwal melalui media sosial dan email.
    </p>
    <p class="p1"><strong>Langkah 2: Waktu Henti Terjadwal Dimulai.</strong></p>
    <p class="p1">
      Pasar Pegasus Exchange akan berhenti sementara. Transaksi dan beberapa
      fitur trading lainnya juga tidak dapat dilakukan.
    </p>
    <p class="p1">
      <strong>Langkah 3: Segera setelah Waktu Henti Terjadwal Selesai.</strong>
    </p>
    <p class="p1"><strong>Langkah 4: Setelah Langkah 3;</strong></p>
    <p class="p1">Pastikan sistem perdagangan berjalan normal.</p>
    <p class="p1">
      Umumkan di
      <a
        href="https://pegasusexchange.id/"
        target="_blank"
        rel="noopener noreferrer"
        >https://pegasusexchange.id/</a
      >
      bahwa Waktu Henti telah berakhir.
    </p>
    <h1 class="text_h">XIV. Lain-lain</h1>
    <p class="p1">
      Sebagai bagian dari pelaksanaan Perdagangan Aset Keuangan Digital, Pegasus
      Exchange dapat mengambil posisi untuk diri sendiri. Dalam hal ini, Pegasus
      Exchange berkomitmen untuk mengikuti pedoman berikut:
    </p>
    <h2 class="text_h">
      1. Memberikan prioritas kepada Konsumen Aset Keuangan Digital dalam
      pengambilan posisi jual atau beli.
    </h2>
    <h2 class="text_h">
      2. Tidak menggunakan dana atau Aset Keuangan Digital milik Konsumen Aset
      Keuangan Digital.
    </h2>
    <p class="p1">
      3. Menggunakan dana atau Aset Keuangan Digital milik Pedagang Aset
      Keuangan Digital sendiri dan menempatkan dana pada rekening terpisah
      Lembaga Kliring Penjaminan dan Penyelesaian sedangkan Aset Keuangan
      Digital ditempatkan di Pengelola Tempat Penyimpanan Aset Keuangan Digital.
    </p>
    <h2 class="text_h">
      4. Melakukan pencatatan tersendiri untuk setiap posisi yang diambil.
    </h2>
    <h1 class="text_h">XV. Lain-lain</h1>
    <p class="p1">
      1. Persyaratan dan ketentuan dalam Aturan Perdagangan ini dapat diubah
      dan/atau ditambahkan dari waktu ke waktu, atas kebijakan Pegasus Exchange
      sendiri.
    </p>
    <p class="p1">
      2. Jika ada pertentangan antara Aturan Perdagangan ini dan pernyataan
      lainnya baik itu secara tertulis atau lisan yang dibuat oleh Pegasus
      Exchange setiap saat (tidak termasuk pernyataan dalam Perjanjian Pegasus
      Exchange lainnya), syarat-syarat Aturan Perdagangan ini akan berlaku.
    </p>
    <p class="p1">
      3. Kecuali apabila Aturan Perdagangan ini menyatakan sebaliknya, Aturan
      Perdagangan akan ditafsirkan sesuai dengan, dan diatur oleh, hukum negara
      Republik Indonesia.
    </p>
    <p class="p1">
      4. Pegasus Exchange tidak akan bertanggung jawab atas segala hal yang
      dilakukan atau tidak dilakukan sesuai dengan Aturan Perdagangan ini.
    </p>
    <p class="p1">
      5. Konsumen menyatakan bahwa Konsumen telah membaca, mengerti, memahami,
      mengamati, menyetujui dan menerima Aturan Perdagangan ini.
    </p>
    <h2 class="text_h">
      6. Aturan Perdagangan ini dibuat dalam bahasa Indonesia dan bahasa
      Inggris.
    </h2>
    <p class="p1">
      Anda dengan ini menyatakan bahwa anda telah menerima dan membaca Aturan
      Perdagangan ini, serta memahami dan menyetujui isinya.
    </p>
    <p class="p1 updated">
      <em>Terakhir Diperbarui pada tanggal 20/05/2026.</em>
    </p>
  </div>
</template>
<script>
// node_modules

// applibs

export default {
  components: {},
  data() {
    return {
      web_domain: "pegasusexchange.id",
    };
  },
};
</script>
<style scoped>
.text_h {
  margin-left: -20px;
  padding-top: 20px;
}
h2.head_txt {
  margin-top: 14pt;
  margin-bottom: 14pt;
  text-align: justify;
  font-size: 18pt;
}
.subtitle {
  font-weight: 600;
  margin-bottom: 1rem;
}
.updated {
  margin-top: 2rem;
  font-style: italic;
}
.p1 {
  margin-top: 14pt;
  margin-bottom: 14pt;
  text-align: justify;
  font-size: 16px;
}
.ul-letter,
.ul-sub {
  margin: 0 0 14pt 0;
  padding-left: 32pt;
  list-style: none;
}
.ul-nested {
  margin-top: 10pt;
  padding-left: 20pt;
}
.li-letter,
.li-sub {
  margin-top: 10pt;
  text-align: justify;
  font-size: 16px;
}
.li-label {
  font-weight: 600;
}
.text_h,
h1,
h2 {
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
}
.ctr_trm {
  max-width: 932px;
  padding: 0 20px;
  z-index: 995;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.head_txt {
  font-size: 28px;
  margin-left: -20px;
}
.ctr_trm a {
  color: #4da3ff;
  word-break: break-all;
}
@media (max-width: 500px) {
  .text_h,
  .head_txt,
  h1,
  h2 {
    font-size: 16px;
    margin-top: 20px;
  }
  .p1,
  .li-letter,
  .li-sub {
    font-size: 14px;
  }
}
</style>
